import styled from 'styled-components';

import Select, { Option } from 'design-system/components/Select';

const Container = styled('div')`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const StyledText = styled('div')`
  padding-left: 12px;
  text-align: right;
`;

const StyledSelect = styled(Select)`
  flex: 1;
`;

interface PageSizeSelectorProps {
  pageSize: number;
  pageSizeOptions: number[];
  handlePageSizeClick: (pageSize: number) => void;
}

export default ({ pageSize, pageSizeOptions, handlePageSizeClick }: PageSizeSelectorProps) => {
  return (
    <Container>
      <StyledText>Items per page:</StyledText>
      <StyledSelect
        size='sm'
        onValueChange={(value) => handlePageSizeClick(Number(value))}
        data-test='pagination__page-size-selector'
        value={String(pageSize)}
      >
        {new Array(pageSizeOptions.length).fill(undefined).map((_, index) => {
          const pageSizeOption = pageSizeOptions[index];
          return (
            <Option
              value={String(pageSizeOption)}
              key={pageSizeOption}
              onClick={() => handlePageSizeClick(pageSizeOption)}
              data-test={`pagination__page-size-selector-option-${pageSizeOption}`}
              aria-label={`Set page size to ${pageSizeOption} items per page`}
            >
              {pageSizeOption}
            </Option>
          );
        })}
      </StyledSelect>
    </Container>
  );
};
